// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce .easycommerce-shipping .easycommerce-shipping-input {
    width: 100%;
    padding: 10px 16px;
    border: 1px solid var(--color-ec-border);
    border-radius: 8px;
    transition: 0.3s all ease-in-out;
}
.easycommerce .easycommerce-shipping .easycommerce-shipping-input:hover {
    border-color: var(--color-ec-secondary);
}
.easycommerce .easycommerce-shipping .easycommerce-shipping-input:focus {
    border-color: var(--color-ec-primary);
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-tertiary);
    outline: none;
}
.easycommerce .easycommerce-shipping .easycommerce-shipping-select {
    width: 100%;
    max-width: 100%;
    border: 1px solid var(--color-ec-border);
    padding: 10px 16px;
    border-radius: 8px;
    color: var(--color-ec-body);
}
.easycommerce .easycommerce-shipping .easycommerce-shipping-select:hover {
    border-color: var(--color-ec-secondary);
}
.easycommerce .easycommerce-shipping .easycommerce-shipping-select:focus {
    color: var(--color-ec-body);
    border: 1px solid var(--color-ec-primary);
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);
    outline: none;
}
.easycommerce .easycommerce-shipping .easycommerce-region-search-input {
    width: 100%;
}
.easycommerce .easycommerce-shipping .easycommerce-shipping-input::-moz-placeholder {
    color: var(--color-ec-placeholder);
    font-size: 14px;
    line-height: 16px;
}
.easycommerce .easycommerce-shipping .easycommerce-shipping-input::placeholder {
    color: var(--color-ec-placeholder);
    font-size: 14px;
    line-height: 16px;
}
.easycommerce .easycommerce-shipping .easycommerce-shipping-method-input {
    width: 98%;
    height: 48px;
    border: 1px solid var(--color-ec-border);
    border-radius: 8px;
    margin-right: 8px;
    margin-bottom: 16px;
    transition: 0.3s all ease-in-out;
}
.easycommerce .easycommerce-shipping .easycommerce-shipping-method-input:hover {
    border-color: var(--color-ec-secondary);
}
.easycommerce .easycommerce-shipping .easycommerce-shipping-method-input:focus,
.easycommerce
    .easycommerce-shipping
    .easycommerce-shipping-method-input:active {
    outline: none;
    border: 1px solid var(--color-ec-primary);
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);
}
.easycommerce-switch {
    position: relative;
    display: inline-block;
    width: 48px;
    height: 24px;
}

.easycommerce-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}
.easycommerce .easycommerce-slider.easycommerce-round {
    border-radius: 34px;
}
.easycommerce .easycommerce-slider.easycommerce-slider:before {
    border-radius: 50%;
}
.easycommerce .easycommerce-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
}

.easycommerce .easycommerce-slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
}

.easycommerce .easycommerce-switch input:checked + .easycommerce-slider {
    background-color: var(--color-ec-primary);
}

.easycommerce .easycommerce-switch input:checked + .easycommerce-slider:before {
    transform: translateX(24px);
}
.easycommerce .easycommerce-slider.easycommerce-round {
    border-radius: 34px;
}
.easycommerce .easycommerce-slider.easycommerce-slider:before {
    border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/shipping/src/assets/css/shipping.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,qCAAqC;IACrC,sDAAsD;IACtD,aAAa;AACjB;AACA;IACI,WAAW;IACX,eAAe;IACf,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,2BAA2B;IAC3B,yCAAyC;IACzC,oDAAoD;IACpD,aAAa;AACjB;AACA;IACI,WAAW;AACf;AACA;IACI,kCAAkC;IAClC,eAAe;IACf,iBAAiB;AACrB;AAJA;IACI,kCAAkC;IAClC,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,uCAAuC;AAC3C;AACA;;;;IAII,aAAa;IACb,yCAAyC;IACzC,oDAAoD;AACxD;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IAEtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IAEvB,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IAGI,2BAA2B;AAC/B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".easycommerce .easycommerce-shipping .easycommerce-shipping-input {\n    width: 100%;\n    padding: 10px 16px;\n    border: 1px solid var(--color-ec-border);\n    border-radius: 8px;\n    transition: 0.3s all ease-in-out;\n}\n.easycommerce .easycommerce-shipping .easycommerce-shipping-input:hover {\n    border-color: var(--color-ec-secondary);\n}\n.easycommerce .easycommerce-shipping .easycommerce-shipping-input:focus {\n    border-color: var(--color-ec-primary);\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-tertiary);\n    outline: none;\n}\n.easycommerce .easycommerce-shipping .easycommerce-shipping-select {\n    width: 100%;\n    max-width: 100%;\n    border: 1px solid var(--color-ec-border);\n    padding: 10px 16px;\n    border-radius: 8px;\n    color: var(--color-ec-body);\n}\n.easycommerce .easycommerce-shipping .easycommerce-shipping-select:hover {\n    border-color: var(--color-ec-secondary);\n}\n.easycommerce .easycommerce-shipping .easycommerce-shipping-select:focus {\n    color: var(--color-ec-body);\n    border: 1px solid var(--color-ec-primary);\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);\n    outline: none;\n}\n.easycommerce .easycommerce-shipping .easycommerce-region-search-input {\n    width: 100%;\n}\n.easycommerce .easycommerce-shipping .easycommerce-shipping-input::placeholder {\n    color: var(--color-ec-placeholder);\n    font-size: 14px;\n    line-height: 16px;\n}\n.easycommerce .easycommerce-shipping .easycommerce-shipping-method-input {\n    width: 98%;\n    height: 48px;\n    border: 1px solid var(--color-ec-border);\n    border-radius: 8px;\n    margin-right: 8px;\n    margin-bottom: 16px;\n    transition: 0.3s all ease-in-out;\n}\n.easycommerce .easycommerce-shipping .easycommerce-shipping-method-input:hover {\n    border-color: var(--color-ec-secondary);\n}\n.easycommerce .easycommerce-shipping .easycommerce-shipping-method-input:focus,\n.easycommerce\n    .easycommerce-shipping\n    .easycommerce-shipping-method-input:active {\n    outline: none;\n    border: 1px solid var(--color-ec-primary);\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);\n}\n.easycommerce-switch {\n    position: relative;\n    display: inline-block;\n    width: 48px;\n    height: 24px;\n}\n\n.easycommerce-switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n.easycommerce .easycommerce-slider.easycommerce-round {\n    border-radius: 34px;\n}\n.easycommerce .easycommerce-slider.easycommerce-slider:before {\n    border-radius: 50%;\n}\n.easycommerce .easycommerce-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n}\n\n.easycommerce .easycommerce-slider:before {\n    position: absolute;\n    content: \"\";\n    height: 20px;\n    width: 20px;\n    left: 2px;\n    bottom: 2px;\n    background-color: white;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n}\n\n.easycommerce .easycommerce-switch input:checked + .easycommerce-slider {\n    background-color: var(--color-ec-primary);\n}\n\n.easycommerce .easycommerce-switch input:checked + .easycommerce-slider:before {\n    -webkit-transform: translateX(24px);\n    -ms-transform: translateX(24px);\n    transform: translateX(24px);\n}\n.easycommerce .easycommerce-slider.easycommerce-round {\n    border-radius: 34px;\n}\n.easycommerce .easycommerce-slider.easycommerce-slider:before {\n    border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
